// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2615":"css/pdf","3937":"css/pdf_consumer_duty_board_report","7015":"css/tailwind","8252":"css/app","9746":"css/pdf_suitability_report_audit"}[chunkId] + ".css";
};